import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'chemical_storage_areas_do_not_have_chemical_spill'

export const dataPointDefinition = {
  retracedId: 'chemical_storage_areas_do_not_have_chemical_spill',
  name: 'Chemical storage areas do not have any chemical spill detection and alarm system',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-che-27x',
      number: 'HS-CHE-11-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-che-21',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-26,Yes- including hazardous substances;Yes- not including hazardous substances',
      machineShowHide: '[2],hs-26,1;2',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-27x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30180,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
